<template src="./template.html"></template>

<script>
  import { mapState, mapActions } from 'vuex'
  import ImageUploader from '@/components/ui/ImageUploader'
  import EditProfile from '@/views/ProfilePage/EditProfile'

  export default {
    name: 'EditProfileImageOverlay',
    components: {
      EditProfile,
      ImageCropper: () => import('@/components/modules/ImageCropper'),
      ImageUploader,
    },
    props: {
      overlayUpload: Boolean,
      overlayEditProfile: Boolean,
      isOwn: Boolean,
      type: String,
      title: String,
      customizedStyles: String,
      uploadTitle: String,
      uploadSubTitle: String,
      config: Object,
    },
    data() {
      return {
        overlayImage: false,
        uploadedImage: {
          id: null,
          src: null,
        },
      }
    },
    computed: {
      ...mapState('users', [
        'user',
        'pending',
      ]),
      ...mapState('groups', { pendingFromGroups: 'pending' }),
      isOverlayOpen() {
        return (
          this.overlayEditProfile ||
          this.overlayImage ||
          this.overlayUpload
        )
      },
    },
    watch: {
      isOverlayOpen(value) {
        this.toggleBodyClass('no-scroll')
      },
    },
    methods: {
      ...mapActions('users', [
        'getUser',
        'updateAvatar',
        'editProfile',
      ]),
      ...mapActions('groups', ['uploadImage']),
      ...mapActions('auth', ['updateImgPath']),
      openImageCropper(image) {
        this.uploadedImage = image
        this.$emit('setOverlayUpload', false)
        this.overlayImage = true
      },
      onAvatarSave(coordinates) {
        if (this.type === 'groups') {
          this.uploadImage({ coordinates, id: this.uploadedImage.id }).then(data => {
            this.overlayImage = false
            this.onSaveImage(data)
          })
        } else {
          this.updateAvatar({ coordinates, id: this.uploadedImage.id }).then(async _ => {
            this.overlayImage = false
            await this.getUser(this.$route.params.id)
            if (this.isOwn) {
              this.updateImgPath(this.user.img_path)
            }
          })
        }

      },
      onEditProfile(userData) {
        this.editProfile(userData).then(_ => {
          this.$emit('setOverlayEditProfile', false)
          this.$emit('showStatusMessage')
          this.getUser(this.$route.params.id)
        })
      },
      onCloseOverlay(value) {
        this.$emit(value)
      },
      onSetNewImage(value) {
        this.$emit('onSetNewImage', value)
      },
      onSaveImage(value) {
        this.$emit('onSaveImage', value)
      },
    },
  }
</script>
